import {useSearchParams} from "react-router";

import {RequiredDateRange} from "@/components/datetime/utils.ts";
import {ExportDropdown} from "@/components/ExportDropdown/ExportDropdown.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {ALERTS_FIXED_RANGE_KEY, ALERTS_RANGE_KEY_FROM, ALERTS_RANGE_KEY_TO} from "@/pages/alerting/AlertsPage.tsx";

export const DownloadExport = ({range}: {range?: RequiredDateRange | null}) => {
  const [queryParams] = useSearchParams();
  queryParams.delete(ALERTS_FIXED_RANGE_KEY);
  if (range) {
    queryParams.set(ALERTS_RANGE_KEY_FROM, range.from.toISOString());
    queryParams.set(ALERTS_RANGE_KEY_TO, range.to.toISOString());
  }
  const baseUrl = `${URL_ORIGINAL_WEBSITE}/alerting/alert-export?${queryParams.toString()}`;

  return <ExportDropdown baseUrl={baseUrl} className={"float-end"} />;
};
